import React from 'react';
import { User, Sliders, Mail, Tag, Wand2, Puzzle, CreditCard, LifeBuoy, LogOut } from 'lucide-react';
import { useTheme } from '../../lib/theme';
import { hardLogout } from '../../lib/auth';

export const SECTIONS = [
  { key: 'profile', label: 'Profile', icon: User },
  { key: 'preferences', label: 'Preferences', icon: Sliders },
  { key: 'email', label: 'Email Inbox & Forwarding', icon: Mail },
  { key: 'categories', label: 'Categories', icon: Tag },
  { key: 'automation', label: 'Automation', icon: Wand2 },
  { key: 'integrations', label: 'Integrations', icon: Puzzle },
  { key: 'billing', label: 'Billing', icon: CreditCard },
  { key: 'support', label: 'Support', icon: LifeBuoy },
];

export default function SettingsNav({ active, onSelect }) {
  const { colors } = useTheme();
  return (
    <nav
      data-testid="settings-nav"
      style={{
        display: 'flex', flexDirection: 'column', gap: 4,
        padding: 14, borderRadius: 14,
        background: colors.surface, border: `1px solid ${colors.border}`,
        position: 'sticky', top: 20, minWidth: 240,
      }}
    >
      {SECTIONS.map(({ key, label, icon: Icon }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`settings-nav-${key}`}
            onClick={() => onSelect(key)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 12px', borderRadius: 10,
              background: isActive ? colors.accentSoft : 'transparent',
              color: isActive ? colors.accent : colors.text,
              border: 'none', cursor: 'pointer',
              fontWeight: isActive ? 700 : 500, fontSize: 14, textAlign: 'left',
              transition: 'background 120ms ease, color 120ms ease',
            }}
          >
            <Icon size={16} />
            <span style={{ flex: 1 }}>{label}</span>
          </button>
        );
      })}
      <div style={{ height: 1, background: colors.border, margin: '10px -4px' }} />
      <button
        type="button"
        data-testid="settings-signout"
        onClick={() => hardLogout('/')}
        style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 12px', borderRadius: 10,
          background: 'transparent', color: '#DC2626',
          border: 'none', cursor: 'pointer',
          fontWeight: 600, fontSize: 14, textAlign: 'left',
        }}
      >
        <LogOut size={16} />
        <span style={{ flex: 1 }}>Sign out</span>
      </button>
    </nav>
  );
}
